// src/config.js
// Production (EC2): leave VUE_APP_API_URL unset → same-origin requests via nginx.
// Development: defaults to local Flask on :5000, or set VUE_APP_API_URL for Cloudflare tunnel.
const API_BASE_URL = process.env.VUE_APP_API_URL
  || (process.env.NODE_ENV === 'production' ? '' : 'http://127.0.0.1:5000');

export default {
  API_BASE_URL,
};
